import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { RegionModel } from "../models";

@Injectable({
  providedIn: "root",
})
export class APIService {

  filename = 'test-data.json';

  constructor(private httpClient: HttpClient) {}

  public ping(region: RegionModel): Observable<any> {
    const { regionName, bucketName } = region;
    let url = "";

    if (!regionName || !bucketName) {
      return new Observable<any>();
    }

    // https://keycore-latency-127941153560-ap-southeast-3.s3-ap-southeast-3.amazonaws.com/test-data.json
    // https://keycore-latency-127941153560-ap-southeast-3.s3.eu-west-1.amazonaws.com/test-data.json

    if (regionName == "us-east-1") {
      url = `https://${bucketName}.s3.amazonaws.com/${this.filename}`;
    } else if (regionName == "eu-south-1" || regionName == "af-south-1" || regionName == "ap-southeast-3") {
      url = `https://${bucketName}.s3.${regionName}.amazonaws.com/${this.filename}`;
    } else {
      url = `https://${bucketName}.s3-${regionName}.amazonaws.com/${this.filename}`;
    }
    const headers = new HttpHeaders({
      "Cache-Control": "no-cache",
      Accept: "*/*",
    });
    return this.httpClient.get(url, { headers, responseType: "text" }).pipe(catchError(this.handleError));
  }

  // Use arrow function so this context is not lost
  private handleError = (error: HttpErrorResponse) => {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      errorMessage = `A client-side or network error occurred: ${error.error.message}`;
    } else {
      if (error.status === 0) {
        errorMessage = "AJAX request was cancelled. ";
      }
      // The backend returned an unsuccessful response code.
      else if (error.status === 404) {
        console.error("Resource not found.");
      }

      // The response body may contain clues as to what went wrong.
      if (error.error && error.error.message) {
        errorMessage += `Server response: ${error.error.message}`;
      }
    }

    // Return an observable with a user-facing error message.
    console.error(errorMessage);
    return throwError(errorMessage);
  };
}
